// ── Action type constants ─────────────────────────────────────────────────────

export const MILEAGE_LOGS_LIST         = 'MILEAGE_LOGS_LIST';
export const MILEAGE_LOG_GET           = 'MILEAGE_LOG_GET';
export const MILEAGE_LOG_CREATE        = 'MILEAGE_LOG_CREATE';
export const MILEAGE_LOG_UPDATE        = 'MILEAGE_LOG_UPDATE';
export const MILEAGE_LOG_DELETE        = 'MILEAGE_LOG_DELETE';

// ── List logs ─────────────────────────────────────────────────────────────────

export const listMileageLogs = (clientId, startDate, endDate, filterUserId) => ({
  type: MILEAGE_LOGS_LIST,
  request: {
    url: '/v2/mileage/logs',
    method: 'GET',
    params: {
      clientId,
      ...(startDate ? { startDate } : {}),
      ...(endDate   ? { endDate }   : {}),
      ...(filterUserId != null ? { filterUserId } : {}),
    },
  },
});

// ── Get single log ────────────────────────────────────────────────────────────

export const getMileageLog = (id) => ({
  type: MILEAGE_LOG_GET,
  id,
  request: {
    url: `/v2/mileage/logs/${id}`,
    method: 'GET',
  },
});

// ── Create log ────────────────────────────────────────────────────────────────

export const createMileageLog = (clientId, data) => ({
  type: MILEAGE_LOG_CREATE,
  request: {
    url: '/v2/mileage/logs',
    method: 'POST',
    params: { clientId },
    data,
  },
});

// ── Update log ────────────────────────────────────────────────────────────────

export const updateMileageLog = (id, data) => ({
  type: MILEAGE_LOG_UPDATE,
  id,
  request: {
    url: `/v2/mileage/logs/${id}`,
    method: 'PUT',
    data,
  },
});

// ── Delete log ────────────────────────────────────────────────────────────────

export const deleteMileageLog = (id) => ({
  type: MILEAGE_LOG_DELETE,
  id,
  request: {
    url: `/v2/mileage/logs/${id}`,
    method: 'DELETE',
  },
});

// ── CSV export ────────────────────────────────────────────────────────────────
// Handled directly via axiosInstance in the component (blob download).
